export default "__VITE_ASSET__CEiCfW2y__"